import { Typography } from '@material-ui/core';
import React from 'react';

export const EmptyNotifications = () => {
  return <Typography variant="subtitle1">You don't have notifications yet</Typography>;
};
